import { AxiosError } from 'axios';
import { UseQueryResult, useQuery } from 'react-query';
import { api } from '../api';
import { useFirmContext } from '../providers/FirmProvider';

async function getBillingDashboardLink(firmId: string): Promise<{ url: string }> {
    const { data } = await api.get(`/firms/${firmId}/billing-dashboard`);
    return data;
}

export function useBillingDashboard(enabled = false): UseQueryResult<{ url: string }, AxiosError> {
    const { id } = useFirmContext();
    return useQuery(['firm', id, 'billing-dashboard'], () => getBillingDashboardLink(id), { enabled });
}
